// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// Internal modules
import { features, getContent } from '@/lib';
import { SelectAllHeader, StyledLink } from './StyledComponents';
import { selectAllChangeHandler } from './handlers';

const SelectAllTerms = (): JSX.Element => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const affectedFields = features.config.selectAllSignupFieldsKeys;

  const currentFieldValues = useStoreState(({ form }) => {
    return affectedFields?.map(
      // @ts-expect-error
      (affectedFieldKey: string) => form[affectedFieldKey]?.value,
    );
  });

  const allSelected = currentFieldValues.every((val: boolean) => val);
  const label = getContent(
    allSelected ? 'terms.unselectAll' : 'terms.selectAll',
  );

  const keyDownHandler = (ev: React.KeyboardEvent) => {
    // on Space or Enter press
    if (['Enter', ' ', 13, 32].includes(ev.key)) {
      ev.preventDefault();
      selectAll(ev);
    }
  };

  const selectAll = (ev: React.MouseEvent | React.KeyboardEvent): void => {
    if (isFormSubmitting) {
      return;
    }
    selectAllChangeHandler(ev, !allSelected, affectedFields);
  };

  return (
    <>
      <SelectAllHeader>{getContent('terms.multiTerms.header')}</SelectAllHeader>
      <StyledLink
        tabIndex={0}
        data-testid={allSelected ? 'unselect-all' : 'select-all'}
        onKeyDown={keyDownHandler}
        onClick={selectAll}
      >
        {label}
      </StyledLink>
    </>
  );
};

export { SelectAllTerms };
